"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
import { Annotation, CoreModel } from "@ym-framework/model";
export let DashboardClientModel = class extends CoreModel {
  constructor() {
    super(...arguments);
    // all_vd:number = 0;
    // need_renew_vd:number = 0;
    // need_bindshop_vd:number = 0;
    // need_bindvd_shop:number = 0;
    // need_renew_shop:number = 0;
    // current_icon:number = 0;
    // simple_risk:number = 0;
    // danger_risk:number =0
    // discount_coupon:number = 0;
    // shop:number = 0
    this.allVD = 0;
    this.needRenewVD = 0;
    this.allShop = 0;
    this.currentCoin = 0;
    this.trafficBalance = 0;
    this.isBuyTravelPackage = false;
    this.regulationExpireTime = null;
  }
};
DashboardClientModel.model = "dashboard.client";
DashboardClientModel = __decorateClass([
  Annotation.ModelMeta
], DashboardClientModel);
